export enum TextEvaluationType {
  NoData = 'NoDoneProvided',
  HighScore = 'Correct',
  MediumScore = 'LowAccuracy',
  LowScore = 'VeryLowAccuracy',
}

type TextEvaluationDetails = Record<
  TextEvaluationType,
  { displayLabel: string; color: string; scoreRequirement: number | undefined }
>;

export const textEvaluationDetails: TextEvaluationDetails = {
  [TextEvaluationType.HighScore]: {
    displayLabel: 'Correct',
    color: '#00A698', // Green
    scoreRequirement: 95,
  },
  [TextEvaluationType.MediumScore]: {
    displayLabel: 'Low accuracy',
    color: '#F6921E', // Orange
    scoreRequirement: 50,
  },
  [TextEvaluationType.LowScore]: {
    displayLabel: 'Very low accuracy',
    color: '#FF5959', // Red
    scoreRequirement: 0,
  },
  [TextEvaluationType.NoData]: {
    displayLabel: 'Not done / Provided',
    color: '#949494', // Grey
    scoreRequirement: undefined, // Indicates no score available
  },
};
